import React from 'react';
import PropTypes from 'prop-types';
import { graphql, createFragmentContainer } from 'react-relay';

// styles
import styles from './PdpRespHeroCarousel.scss';

// helpers
import get from 'lodash.get';

export function PdpRespHeroCarouselPrint(props) {
    return (
        <div className={styles.printCarousel}>
            <img className={styles.printImage} src={get(props, 'item.photos[0].largePath')} />
        </div>
    );
}

PdpRespHeroCarouselPrint.propTypes = {
    item: PropTypes.object.isRequired,
};

export default createFragmentContainer(PdpRespHeroCarouselPrint, {
    item: graphql`
        fragment PdpRespHeroCarouselPrint_item on Item {
            photos {
                largePath
            }
        }
    `,
});
